import { ModalShowHide } from '../components/modal';
import Cart from './cart';
import Shipping from './shipping';
import FindInStore from '../product/findinstore';
import PickupPoint from '../checkout/pickupPoint';
import { lazyload } from '../util/lazyload';
import SlovakParcelService from 'checkout/slovakParcelService/slovakParcelServicePUP';
import '../components/greenChoice';

function enableExpressButton (data, isFirstCourierApple) {
    var expressMethodEnabled = true;
    if (data.items) {
        const orderItems = data.items;
        for (let item of orderItems) {
            if (item.wrappedQuantity || item.wrappedQuantity > 0 || item.isGiftKit) {
                expressMethodEnabled = false;
            }
        }
    }
    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (isFirstCourierApple) {
            $('.js-apple-pay-container').removeClass('disabled');
        } else {
            $('.js-apple-pay-container').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
}

function showInventoryError () {
    var container = $('.page').data('action') === 'Cart-Show' ? $('.js-cart-error-reserve') : $('.js-reserve-error-checkout');
    container
        .show()
        .find('.error-message-text')
        .text(container.data('inventoryMessage'));
    $('html, body').animate({ scrollTop: 0 });
}

export class ExpressCheckout {
    run () {
        this.updateExpressButton();
        this.selectShippingMethod();
        this.shippingMethodinitialize();
        this.expressModalFlow();
    }

    selectShippingMethod () {
        $(document).on('click touchstart', '.shipping-express-form .js-shipping-types-express', function () {
            if (!$(this).hasClass('shipping-method-selected')) {
                var methodID = $(this).find('.js-shipping-method').val();
                $(this).find('.js-shipping-method').prop('checked', true);
                $('.js-shipping-types-express').removeClass('shop-selected');
                $('.js-shipping-types-express').removeClass('shipping-method-selected');
                $('.js-shipping-type-express-' + methodID).addClass('shipping-method-selected');
                $('.js-expressButtonContinue').prop('disabled', false);
                $('.error-message.generic-express').hide();
                if (!Foundation.MediaQuery.is('medium')) {
                    $('.shipping-methods-list').animate({
                        scrollTop: $('.js-shipping-type-express-' + methodID).offset().top - $('.shipping-step-modal').offset().top - 30
                    }, 'slow');
                }
                if ($(this).hasClass('point-method')) {
                    $('.js-shipping-type-express-' + methodID).addClass('shop-selected');
                    $('.js-expressButtonContinue').prop('disabled', true);
                    var isStorePickup = $(this).find('.js-shipping-method').data('pickup');
                    var isPUP = $(this).find('.js-shipping-method').data('pickup-point');
                    if (isStorePickup) {
                        if ($('.shipping-express-form #storeId').val()) {
                            $('.express-flow-modal-custom .js-select-store').hide();
                            $('.express-flow-modal-custom .selectedStoreRecap').show();
                            $('.js-expressButtonContinue').prop('disabled', false);
                        } else {
                            $('.express-flow-modal-custom .js-select-store').show();
                            $('.express-flow-modal-custom .selectedStoreRecap').hide();
                        }
                    } else if (isPUP) {
                        var pupType = $(this).find('.js-shipping-method').data('pickup-point-type');
                        if (pupType === 'SwissPostPUP') {
                            if ($('.shipping-express-form #swissPickUpPointNumber').val() && $('.shipping-express-form #swissPickUpPointTypeName').val()) {
                                $('.express-flow-modal-custom .selectedSwissPostPickupPointRecap').show();
                                $('.js-expressButtonContinue').prop('disabled', false);
                            } else {
                                $('.express-flow-modal-custom .js-select-swiss-point').show();
                                $('.express-flow-modal-custom .selectedSwissPostPickupPointRecap').hide();
                            }
                        } else {
                            var methodIdLastPup = $('.pickUpPointIdSelected').val();
                            let pupRecap = '';
                            let pupButton = '';
                            if (pupType === 'SPS') {
                                pupButton = '  .js-select-pickup-SPS';
                                pupRecap = '  .selectedPickupRecapSPS';
                            } else if (pupType === 'ExpressOnePUP') {
                                pupButton = '  .js-select-eo-pup';
                                pupRecap = '  .selectedExpressOnePickupPointRecap';
                            } else if (pupType === 'PPLPUP') {
                                pupButton = '  .js-select-pickup-PPL';
                                pupRecap = '  .selectedPickupRecapPPL';
                            } else if (pupType === 'DHLLocationPUP') {
                                pupButton = '  .js-select-pickup-DHL';
                                pupRecap = '  .selectedPickupRecapDHL';
                            } else if (pupType === 'DPDPUP') {
                                pupButton = '  .js-select-pickup-DPD';
                                pupRecap = '  .selectedPickupRecapDPD';
                            } else if (pupType === 'HERMES') {
                                pupButton = '  .js-select-pickup-hermes';
                                pupRecap = '  .selectedPickupRecapHermes';
                            } else if (pupType === 'CLSS') {
                                pupButton = '  .js-select-pickup-CLSS';
                                pupRecap = '  .selectedPickupRecapCLSS';
                            } else if (pupType === 'BPOST') {
                                pupButton = '  .js-select-pickup-BPOST';
                                pupRecap = '  .selectedPickupRecapBPOST';
                            } else if (pupType === 'PDB') {
                                pupButton = '  .js-select-pickup-PDB';
                                pupRecap = '  .selectedPickupRecapPDB';
                            } else if (pupType === 'EVR') {
                                pupButton = '  .js-select-pickup-EVR';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'PTN') {
                                pupButton = '  .js-select-pickup-PTN';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'EST') {
                                pupButton = '  .js-select-pickup-EST';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'DEL') {
                                pupButton = '  .js-select-pickup-DEL';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'CTT') {
                                pupButton = '  .js-select-pickup-CTT';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'GLS') {
                                pupButton = '  .js-select-pickup-GLS';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'MRE') {
                                pupButton = '  .js-select-pickup-MRE';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'GLSHU') {
                                pupButton = '  .js-select-pickup-GLSHU';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'FAN') {
                                pupButton = '  .js-select-pickup-FAN';
                                pupRecap = '  .cc-selectedPickupRecap';
                            } else if (pupType === 'XBS') {
                                pupButton = '  .js-select-pickup-XBS';
                                pupRecap = '  .cc-selectedPickupRecap';
                            }
                            if ($('.shipping-express-form #pickUpPointNumber').val() && $('.shipping-express-form #pickUpPointName').val() && methodIdLastPup === methodID) {
                                if (pupRecap === '' || pupButton === '') {
                                    $('.express-flow-modal-custom .js-select-point').hide();
                                    $('.express-flow-modal-custom .selectedPickupPointRecap').show();
                                } else {
                                    $('.express-flow-modal-custom' + pupButton).addClass('hide');
                                    $('.express-flow-modal-custom' + pupRecap).removeClass('hide');
                                }
                                $('.js-expressButtonContinue').prop('disabled', false);
                            } else {
                                $('.js-expressButtonContinue').prop('disabled', true);
                                if (pupRecap === '' || pupButton === '') {
                                    $('.express-flow-modal-custom .js-select-point').attr('style', '');
                                    $('.express-flow-modal-custom .selectedPickupPointRecap').hide();
                                } else {
                                    $('.express-flow-modal-custom' + pupButton).removeClass('hide');
                                    $('.express-flow-modal-custom' + pupRecap).addClass('hide');
                                }
                            }
                        }
                    }
                }
            }
        });
        $('body').on('expressPickupPoint:select', function (_e, d) {
            $('.express-button-modal .payment-step-modal .js-point-name').html(d.name);
            $('.express-button-modal .payment-step-modal .js-point-address1').html(d.address1);
            $('.express-button-modal .payment-step-modal .js-point-address2').html(d.city);
            $('.express-button-modal .payment-step-modal .js-point-postal-code').html(d.postalCode);
            if ($('.js-shipping-types-express.shipping-method-selected').length) {
                var methodID = $('.js-shipping-types-express.shipping-method-selected').find('.js-shipping-method').val();
                $('.pickUpPointIdSelected').val(methodID);
            }
        });
    }

    shippingMethodinitialize () {
        $('body').on('findinstore:selectedStore', (_e, d) => {
            $('.shipping-form').append('<input type="hidden" id="storeId" name="storeId" value="' + d + '"/>');
            $('.shipping-express-form').append('<input type="hidden" id="storeId" name="storeId" value="' + d + '"/>');
            $('#storeId').val(d);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('pickupoint:selectedPickup pickupPoint:selectedPoint', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('body').trigger('expressPickupPoint:select', d);
            $('.pickup-point-result').hide();
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('InPost:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('.shipping-form #pickUpPointNumber').remove();
            $('.shipping-form #pickUpPointName').remove();
            $('.shipping-form #pickUpPointAddress1').remove();
            $('.shipping-form #pickUpPointCity').remove();
            $('.shipping-form #pickUpPointPostalCode').remove();

            // Create the elements for the current selection
            $('.shipping-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.name + '"/>');
            $('.shipping-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="InPost PUP"/>');
            $('.shipping-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('BRT:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' + d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('swissPickupPoint:select', (_e, d) => {
            // Remove previous selection for swiss pickup point
            $('input[name$=swissPickUpPointNumber]').remove();
            $('input[name$=swissPickUpPointTypeId]').remove();
            $('input[name$=swissPickUpPointType]').remove();
            $('input[name$=swissPickUpPointTypeName]').remove();
            $('input[name$=swissPickUpPointTechnicalZip]').remove();
            $('input[name$=swissPickUpPointStreet]').remove();
            $('input[name$=swissPickUpPointCity]').remove();
            $('input[name$=swissPickUpPointZip]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointNumber" name="swissPickUpPointNumber" value="' +
                d.poiId + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointTypeId" name="swissPickUpPointTypeId" value="' +
                d.poiTypeId + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointTypeName" name="swissPickUpPointTypeName" value="' +
                d.poiTypeName + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointTechnicalZip" name="swissPickUpPointTechnicalZip" value="' +
                d.technicalZip6 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointStreet" name="swissPickUpPointStreet" value="' +
                d.street + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointCity" name="swissPickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="swissPickUpPointZip" name="swissPickUpPointZip" value="' +
                d.zip + '"/>');
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('novaPoshta:selectedPickUpPoint', (_e, data) => {
            // Remove previous selection for pickup point
            $('.shipping-form #novaPoshtaWarehouseRef').remove();
            $('.shipping-form #novaPoshtaWarehouseNameUa').remove();
            $('.shipping-form #novaPoshtaWarehouseNameRu').remove();
            $('.shipping-form #novaPoshtaWarehouseAddressUa').remove();
            $('.shipping-form #novaPoshtaWarehouseAddressRu').remove();
            $('.shipping-form #novaPoshtaWarehouseCityUa').remove();
            $('.shipping-form #novaPoshtaWarehouseCityRu').remove();
            $('.shipping-form #novaPoshtaWarehousePostalCode').remove();

            // Create elements
            $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseRef" name="novaPoshtaWarehouseRef" value="' + data.ref + '"/>');
            $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseNameUa" name="novaPoshtaWarehouseNameUa" value="' + data.nameUa + '"/>');
            $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseNameRu" name="novaPoshtaWarehouseNameRu" value="' + data.nameRu + '"/>');
            $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseAddressUa" name="novaPoshtaWarehouseAddressUa" value="' + data.addressUa + '"/>');
            $('.shipping-form').append('<input type="hidden" id="novaPoshtaWarehouseAddressRu" name="novaPoshtaWarehouseAddressRu" value="' + data.addressRu + '"/>');
            $('<input type="hidden" id="novaPoshtaWarehouseCityUa" name="novaPoshtaWarehouseCityUa"/>').val(data.cityUa || '').appendTo('.shipping-form');
            $('<input type="hidden" id="novaPoshtaWarehouseCityRu" name="novaPoshtaWarehouseCityRu"/>').val(data.cityRu || '').appendTo('.shipping-form');
            $('<input type="hidden" id="novaPoshtaWarehousePostalCode" name="novaPoshtaWarehousePostalCode"/>').val(data.postalCode || '').appendTo('.shipping-form');

            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('OSM:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('.shipping-form #pickUpPointNumber').remove();
            $('.shipping-form #pickUpPointName').remove();
            $('.shipping-form #pickUpPointAddress1').remove();
            $('.shipping-form #pickUpPointCity').remove();
            $('.shipping-form #pickUpPointPostalCode').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' + d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('click', '.js-choose-point', (e) => {
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('PPL:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.js-pickup-name-PPL').data('info', d.name);
            $('.js-pickup-address1-PPL').data('info', d.address1);
            $('.js-pickup-address2-PPL').data('info', d.city);
            $('.js-pickup-postalcode-PPL').data('info', d.postalCode);
            $('.js-pickup-sap-PPL').data('info', d.sap);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.js-expressButtonContinue').prop('disabled', false);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
        });

        $('body').on('CLSS:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.js-pickup-name-CLSS').data('info', d.name);
            $('.js-pickup-address1-CLSS').data('info', d.address1);
            $('.js-pickup-address2-CLSS').data('info', d.city);
            $('.js-pickup-postalcode-CLSS').data('info', d.postalCode);
            $('.js-pickup-sap-CLSS').data('info', d.sap);
            $('.js-pickup-type-CLSS').data('info', d.type);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('DHL:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();
            $('input[name$=dhlLocker]').remove();
            $('input[name$=dhlpostnumber]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="dhlLocker" name="dhlLocker" value="' +
                d.isPackstation + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="dhlpostnumber" name="dhlpostnumber" value=""/>');

            $('.js-pickup-name-DHL').data('info', d.name);
            $('.js-pickup-address1-DHL').data('info', d.address1);
            $('.js-pickup-address2-DHL').data('info', d.city);
            $('.js-pickup-postalcode-DHL').data('info', d.postalCode);
            $('.js-pickup-sap-DHL').data('info', d.sap);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            if (!d.isPackstation) {
                $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                $('.js-expressButtonContinue').prop('disabled', false);
            } else {
                $('.next-step-button').find('.submit-shipping').prop('disabled', true);
                $('.js-expressButtonContinue').prop('disabled', true);
                var postnumber = $('.selectedPickupRecapDHL').find('#dhl-postnumber');
                postnumber.on('keyup', function (e) {
                    $('.shipping-form, .shipping-express-form').find('input[name="dhlpostnumber"]').val($(e.currentTarget).val());
                    postnumber.val($(e.currentTarget).val());
                    $('.next-step-button').find('.submit-shipping').prop('disabled', !$(e.currentTarget).is(':valid'));
                    $('.js-expressButtonContinue').prop('disabled', !$(e.currentTarget).is(':valid'));
                });
            }
        });

        $('body').on('SPS:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.js-pickup-name-SPS').data('info', d.name);
            $('.js-pickup-address1-SPS').data('info', d.address1);
            $('.js-pickup-address2-SPS').data('info', d.city);
            $('.js-pickup-postalcode-SPS').data('info', d.postalCode);
            $('.js-pickup-sap-SPS').data('info', d.sap);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('DPD:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.js-pickup-name-DPD').data('info', d.name);
            $('.js-pickup-address1-DPD').data('info', d.address1);
            $('.js-pickup-address2-DPD').data('info', d.city);
            $('.js-pickup-postalcode-DPD').data('info', d.postalCode);
            $('.js-pickup-sap-DPD').data('info', d.sap);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('Hermes:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.sap + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');

            $('.js-pickup-name-hermes').data('info', d.name);
            $('.js-pickup-address1-hermes').data('info', d.address1);
            $('.js-pickup-address2-hermes').data('info', d.city);
            $('.js-pickup-postalcode-hermes').data('info', d.postalCode);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('PDB:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointNameSummary]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();
            $('input[name$=pickUpPointType]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.serviceType + '"/>'); // PDB needs serviceType as pickupPointName to close the order
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNameSummary" name="pickUpPointNameSummary" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointType" name="pickUpPointType" value="' +
                d.type + '"/>');

            $('.js-pickup-name-PDB').data('info', d.name);
            $('.js-pickup-address1-PDB').data('info', d.address1);
            $('.js-pickup-address2-PDB').data('info', d.city);
            $('.js-pickup-postalcode-PDB').data('info', d.postalCode);
            $('.js-pickup-sap-PDB').data('info', d.number);
            $('.js-pickup-type-PDB').data('info', d.type);
            $('.js-pickup-servicetype-PDB').data('info', d.serviceType);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });
        $('body').on('FAN:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointNameSummary]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();
            $('input[name$=pickUpPointType]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>'); // FAN needs serviceType as pickupPointName to close the order
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNameSummary" name="pickUpPointNameSummary" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointType" name="pickUpPointType" value="' +
                d.type + '"/>');

            $('.js-pickup-name-FAN').data('info', d.name);
            $('.js-pickup-address1-FAN').data('info', d.address1);
            $('.js-pickup-address2-FAN').data('info', d.city);
            $('.js-pickup-postalcode-FAN').data('info', d.postalCode);
            $('.js-pickup-sap-FAN').data('info', d.number);
            $('.js-pickup-type-FAN').data('info', d.type);
            $('.js-pickup-servicetype-FAN').data('info', d.serviceType);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('STANDARD:selectedPickup', (_e, d) => {
            // Remove previous selection for pickup point
            $('input[name$=pickUpPointNumber]').remove();
            $('input[name$=pickUpPointName]').remove();
            $('input[name$=pickUpPointAddress1]').remove();
            $('input[name$=pickUpPointCity]').remove();
            $('input[name$=pickUpPointPostalCode]').remove();
            $('input[name$=pickUpPointType]').remove();

            // Create the elements for the current selection
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointNumber" name="pickUpPointNumber" value="' +
                d.number + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointName" name="pickUpPointName" value="' +
                d.name + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointAddress1" name="pickUpPointAddress1" value="' +
                d.address1 + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointCity" name="pickUpPointCity" value="' +
                d.city + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointPostalCode" name="pickUpPointPostalCode" value="' +
                d.postalCode + '"/>');
            $('.shipping-form, .shipping-express-form').append('<input type="hidden" id="pickUpPointType" name="pickUpPointType" value="' +
                d.type + '"/>');

            $('.js-pickup-name-' + d.shippingMethodType).data('info', d.name);
            $('.js-pickup-address1-' + d.shippingMethodType).data('info', d.address1);
            $('.js-pickup-address2-' + d.shippingMethodType).data('info', d.city);
            $('.js-pickup-postalcode-' + d.shippingMethodType).data('info', d.postalCode);
            $('.js-pickup-sap-' + d.shippingMethodType).data('info', d.number);
            $('.js-pickup-type-' + d.shippingMethodType).data('info', d.type);

            $('.pickup-point-result').hide();
            $('body').trigger('expressPickupPoint:select', d);
            $('.shipping-method').prop('data-pickupchosen', false);
            $('.shipping-method-selected').prop('data-pickupchosen', true);
            $('.next-step-button').find('.submit-shipping').prop('disabled', false);
            $('.js-expressButtonContinue').prop('disabled', false);
        });

        $('body').on('click', '.express-one-pickup-point-btn', function (e) {
            e.preventDefault();
            const modal = new ModalShowHide('#pickupPointExpressOne');
            modal.show();
            $('body').on('click', '#pickupPointExpressOne .close-button-modal', (e) => {
                modal.hide();
            });
            $('body').on('pickupoint:selectedPickup', function (e) {
                modal.hide();
            });
        });

        if (!Foundation.MediaQuery.atLeast('medium')) {
            $('#swissPostModal').parent().addClass('hide');
        }
        $('body').on('click touchstart', '.swiss-pickup-point-btn', function (e) {
            e.preventDefault();
            const modal = new ModalShowHide('#swissPostModal', false, true);
            modal.show();
            if (!Foundation.MediaQuery.atLeast('medium')) {
                $('#swissPostModal').parent().removeClass('hide');
            }
            $('#PostStao .search-and-filter_area .search-area .search-input .search-input_icon-button .icon-search').eq(0).css('background-image', 'none');
            $('body').on('click', '#swissPostModal .close-button-modal', (e) => {
                modal.hide();
                if (!Foundation.MediaQuery.atLeast('medium')) {
                    $('#swissPostModal').parent().addClass('hide');
                }
            });
            $('body').on('swissPickupPoint:select', function (e) {
                modal.hide();
                if (!Foundation.MediaQuery.atLeast('medium')) {
                    $('#swissPostModal').parent().addClass('hide');
                }
            });
        });
    }

    updateExpressButton () {
        if (window.ApplePaySession && window.ApplePaySession.canMakePayments() && $('#apple-pay-btn').length) {
            $('.js-apple-pay-container').show();
        }

        const openModalExpress = new ModalShowHide('#expressButtonModalLight');
        $('body').on('click', '.js-ModalExpressButton-applePay', function (e) {
            //to remove the google pay express checkout param in case user switch from google pay to apple pay
            $('.shipping-express-form input[name="isExpressGooglePay"]').remove();
            $('#add-to-condition-sale-list_express_applepay').prop('checked', false);
            $('.js-express-button').addClass('disableExpressButton');
            $('#add-to-condition-sale-list_express_applepay').parsley().reset();
            $('body').trigger('analytics:fakeExpressButton', { type: 'pay_with_applepay' });
            openModalExpress.show();
        });

        $('body').on('click', '.js-ModalExpressButton-amazonPay', function (e) {
            //to remove the google pay express checkout param in case user switch from google pay to amazon pay
            $('.shipping-express-form input[name="isExpressGooglePay"]').remove();
            $('#add-to-condition-sale-list_express_amazonPay').prop('checked', false);
            $('.js-express-button').addClass('disableExpressButton');
            $('#add-to-condition-sale-list_express_amazonPay').parsley().reset();
            $('body').trigger('analytics:fakeExpressButton', { type: 'pay_with_amazon_pay' });
            let openModalExpressAmazon = new ModalShowHide('#expressButtonModal', 'isOpenExpress', true, '.js-shipping-types');
            openModalExpressAmazon.show('isOpenExpress');
            $('.confirm-express-payment').hide();
            $('.amazon-confirm-express').show();
            $('body').trigger('express-modal:open', { paymentMethod: 'AMAZONPAY' });

            $('body').on('express-modal:close-amazon', function () {
                if (openModalExpressAmazon.isOpenTypeCustom) {
                    openModalExpressAmazon.hide('isOpenExpress');
                }
            });
        });

        $('body').on('click', '.klarna-express-btn-cart', function (e) {
            $('body').trigger('analytics:paymentFastCheckout', {
                method: 'klarna'
            });
        });

        $('body').on('click', '.amazon-pay-real-button', function (e) {
            $('body').trigger('analytics:paymentFastCheckout', {
                method: 'amazon_pay'
            });
            $.spinner().start();
            $.ajax({
                url: $(e.currentTarget).data('startCheckoutUrl'),
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else if (data.inventoryError) {
                            showInventoryError();
                            $('body').trigger('express-modal:close-amazon');
                        }
                    } else {
                        window.location = data.continueUrl;
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        let openModalExpressKlarna;
        $('body').on('click', '.js-ModalExpressButton-klarna', function (e) {
            // //to remove the google pay express checkout param in case user switch from google pay to klarna
            $('.shipping-express-form input[name="isExpressGooglePay"]').remove();
            $('#add-to-condition-sale-list_express_klarna').prop('checked', false);
            $('.js-express-button').addClass('disableExpressButton');
            $('#klarnaExpressCheckout').addClass('disableExpressButton disabled');
            $('#add-to-condition-sale-list_express_klarna').parsley().reset();
            $('body').trigger('analytics:fakeExpressButton', {type: 'pay_with_klarna'});
            openModalExpressKlarna = new ModalShowHide('#expressButtonModal', 'isOpenExpress', true, '.js-shipping-types');
            openModalExpressKlarna.show('isOpenExpress');
            $('.confirm-express-payment').hide();
            $('.klarna-confirm-express').show();
            $('body').trigger('express-modal:open', {paymentMethod: 'klarna'});
            lazyload($('#express-container')).then((rsp) => {
                $('#express-container').html(rsp).data('lazyurl', undefined);
                FindInStore.run(false);
                PickupPoint.run();
                let countryCode = document.getElementById('country-code') && document.getElementById('country-code').value ? document.getElementById('country-code').value : null;
                if ($('.page').data('action') === 'Cart-Show' && countryCode === 'SK') {
                    const slovakParcelService = new SlovakParcelService();
                    slovakParcelService.run();
                }
            });
        });

        $('body').on('change', '[name^="consTrattamento_express_klarna"]', function (e) {
            let validator = $(e.currentTarget).is(':checked');
            if (!validator) {
                $('#klarnaExpressCheckout').addClass('disableExpressButton disabled');
            } else {
                $('#klarnaExpressCheckout').removeClass('disableExpressButton disabled');
            }
        });

        let openModalExpressGoogle;
        $('body').on('click', '.js-ModalExpressButton-googlePay', function (e) {
            $('#add-to-condition-sale-list_express_googlePay').prop('checked', false);
            $('.js-express-button').addClass('disableExpressButton');
            $('#add-to-condition-sale-list_express_googlePay').parsley().reset();
            $('body').trigger('analytics:fakeExpressButton', { type: 'pay_with_google_pay' });
            openModalExpressGoogle = new ModalShowHide('#expressButtonModal', 'isOpenExpress', true, '.js-shipping-types');
            openModalExpressGoogle.show('isOpenExpress');
            $('.confirm-express-payment').hide();
            $('.google-confirm-express').show();
            $('body').trigger('express-modal:open', { paymentMethod: 'GOOGLEPAY' });
            // Add a hidden input to indicate Google Pay express checkout
            $('.shipping-express-form').append('<input type="hidden" name="isExpressGooglePay" value="true">');
            lazyload($('#express-container')).then((rsp) => {
                $('#express-container').html(rsp).data('lazyurl', undefined);
                FindInStore.run(false);
                PickupPoint.run();
                let countryCode = document.getElementById('country-code') && document.getElementById('country-code').value ? document.getElementById('country-code').value : null;
                if ($('.page').data('action') === 'Cart-Show' && countryCode === 'SK') {
                    const slovakParcelService = new SlovakParcelService();
                    slovakParcelService.run();
                }
            });
        });

        $('body').on('googlepay:sheet-open', function () {
            openModalExpressGoogle.hide('isOpenExpress');
        });

        $('body').on('change', '.policy-express-payment .add-to-condition-sale-list_express, [name^="consTrattamento_DW_APPLE_PAY"]', function (e) {
            let validator = $(e.currentTarget).parsley();
            validator.validate();
            if (!validator.isValid()) {
                $('.js-express-button').addClass('disableExpressButton');
            } else {
                $('.js-express-button').removeClass('disableExpressButton');
            }
        });
        $('body').on('click', '.js-express-button', function (e) {
            if (!$('.js-apple-pay-container').hasClass('disableExpressButton') && !$('.js-apple-pay-container').hasClass('isStandardFlow')) {
                openModalExpress.hide();
            }
            let validatorContainer = $('#add-to-condition-sale-list_express_applepay');
            if ($(e.currentTarget).hasClass('js-paypal-container')) {
                validatorContainer = $('#add-to-condition-sale-list_express_paypal');
            } else if ($(e.currentTarget).hasClass('js-amazon-pay-container')) {
                validatorContainer = $('#add-to-condition-sale-list_express_amazonPay');
            } else if ($(e.currentTarget).hasClass('js-google-pay-container')) {
                validatorContainer = $('#add-to-condition-sale-list_express_googlePay');
            } else if ($(e.currentTarget).hasClass('js-klarna-pay-container')) {
                validatorContainer = $('#add-to-condition-sale-list_express_klarna');
            }
            let validator = validatorContainer.parsley();
            validator.validate();
            if (!validator.isValid()) {
                $('.js-express-button').addClass('disableExpressButton');
            } else {
                $('.js-express-button').removeClass('disableExpressButton');
            }
        });

        var amazonShippingNotConfirmed = false;
        var prevConfirmedShippingIndex = 0;
        $('body').on('express-modal:open', function (_, d) {
            var paymentMethod = d.paymentMethod;
            var nonCourierShippingMethods = $('.shipping-express-form .shipping-type-aggregator').not('[data-shipping-type="courier"]');
            if (paymentMethod === 'AMAZONPAY') {
                // for AmazonPay show only the courier shipping methods
                nonCourierShippingMethods.hide();

                var selectedShipping = $('.shipping-method.js-shipping-types-express.shipping-method-selected');
                if (selectedShipping.data('shippingType') !== 'courier') {
                    // auto-select the first courier shipping method
                    selectedShipping.removeClass('shipping-method-selected');
                    $('.shipping-method.js-shipping-types-express').not(nonCourierShippingMethods).first().click();

                    if ($('#expressButtonModal').attr('data-modal-stage') === 'payment') {
                        // go back to the shipping method selection
                        $('#expressButtonModal').attr('data-modal-stage', 'shipping');
                        amazonShippingNotConfirmed = true;
                        prevConfirmedShippingIndex = selectedShipping.data('index');
                    }
                }
            } else {
                nonCourierShippingMethods.show();
                if (amazonShippingNotConfirmed) {
                    // if the shipping is not confirmed for amazon, go automatically to the payment step when another payment method is selected.
                    amazonShippingNotConfirmed = false;
                    $('#expressButtonModal').attr('data-modal-stage', 'payment');
                    $('.shipping-method.js-shipping-types-express.shipping-method-selected').removeClass('shipping-method-selected');
                    $('.shipping-method.js-shipping-types-express[data-index="' + prevConfirmedShippingIndex + '"]').click();
                }
            }
        });

        $('body').on('express-modal:shipping-selection-confirmed', function () {
            amazonShippingNotConfirmed = false;
            prevConfirmedShippingIndex = 0;
            $('body').trigger('googlePay:updateTransactionDetails');
        });

        $('body').on('removeItemFromCartSuccessful', function (_, data) {
            var areGiftCardsInBasket = data.cartModel && data.cartModel.items ? data.cartModel.items.some(item => {
                return item.isGiftCard;
            }) : false;
            if (!areGiftCardsInBasket) {
                $('.js-amazon-pay-container').removeClass('hidden');
            }
            $('body').trigger('googlePay:updateTransactionDetails');
        });
    }

    expressModalFlow () {
        $('body').on('click', '.js-expressButtonContinue', (e) => {
            e.preventDefault();
            $.spinner().start();
            var $expressForm = $('.js-expressButtonContinue').closest('.express-button-modal');
            var methodID = $expressForm.find('.shipping-method-selected .js-shipping-method').val();
            var serializedData = $('.shipping-express-form').serialize();
            serializedData += '&methodID=' + methodID;
            var analyticsShippingType = 'home_standard';
            var analyticsName = '';
            if ($expressForm.find('.shipping-method-selected .js-shipping-method').data('pickup') == true) {
                analyticsShippingType = 'shop';
                analyticsName = $expressForm.find('.shipping-method-selected .analytics-shipping-point-name').html();
            } else if ($expressForm.find('.shipping-method-selected .js-shipping-method').data('pickup-point') == true) {
                analyticsShippingType = 'pickup_point';
                analyticsName = $expressForm.find('.shipping-method-selected .analytics-shipping-point-name').html();
            } else if ($expressForm.find('.shipping-method-selected .js-shipping-method').data('is-express-shipping') == true) {
                analyticsShippingType = 'home_express';
            }
            $('body').trigger('analytics:fastCheckoutShippingMethod', {
                type: analyticsShippingType,
                name: analyticsName
            });
            $.ajax({
                url: $('.shipping-method-list-express').data('action-url'),
                method: 'POST',
                data: serializedData,
                success: function (data) {
                    if (data.error) {
                        $('.error-message.generic-express').show();
                    } else {
                        if (!data.totals) {
                            $.spinner().stop();
                            return;
                        }
                        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                        $('.promos').empty().append(data.totals.promocodesHtml);
                        Cart.updateCartTotals(data, false, true);
                        Cart.updateApproachingDiscounts(data.approachingDiscounts);
                        Cart.updateReachedDiscounts(data.appliedShippingDiscounts);
                        $('body').trigger('setShippingMethodSelection', data);
                        $('body').trigger('express-modal:shipping-selection-confirmed');
                        if (data.shipments && data.shipments.length) {
                            var firstCourierAppleEnabled = '';
                            data.shipments[0].shippingMethods.forEach(function (shippingMethod) {
                                if (!firstCourierAppleEnabled && shippingMethod.shippingType && shippingMethod.shippingType.value === 'courier') {
                                    firstCourierAppleEnabled = shippingMethod.ID;
                                }
                                if (shippingMethod.selected) {
                                    $('.shipping-method-label-express').empty().append(shippingMethod.shippingMethodRecapTitle);
                                    enableExpressButton(data, firstCourierAppleEnabled === shippingMethod.ID);
                                    // Manage the shipping price:
                                    // 1- If the shipping is free, show the "free" label
                                    // 2- If the shipping is NOT free, show the price
                                    if (shippingMethod.isFree) {
                                        $('.js-free-shipping').removeClass('hide');
                                        $('.js-paid-shipping').addClass('hide');
                                    } else {
                                        $('.js-free-shipping').addClass('hide');
                                        $('.js-paid-shipping').empty().append(data.totals.totalShippingCost).removeClass('hide');
                                    }
                                    if (shippingMethod.estimatedArriveDays) {
                                        $('.shipping-method-estimated-arrive-express').empty().append(shippingMethod.estimatedArriveDays);
                                    } else {
                                        $('.shipping-method-estimated-arrive-express').empty();
                                    }
                                    $('.js-shipping-types').removeClass('shop-selected');
                                    $('.js-shipping-types').removeClass('shipping-method-selected');
                                    $('.js-shipping-type-' + shippingMethod.ID).addClass('shipping-method-selected');
                                    $('.js-shipping-types').removeClass('shipping-method-express-confirmed');
                                    $('.js-shipping-type-' + shippingMethod.ID).addClass('shipping-method-express-confirmed');
                                    $('.shipping-method-list .js-shipping-types:not(.js-shipping-types-express).js-shipping-type-' + shippingMethod.ID).find('.js-shipping-method').prop('checked', true);
                                    $('.analyticsExpressShipping').data('is-express-shipping', 'false');
                                    if ($('.data-checkout-stage').data('customer-type') === 'guest') {
                                        Shipping.methods.clearInputFields();
                                    }
                                    $('.js-shipping-cost-tooltip').removeClass('hide');
                                    $('.js-recap-store-name').addClass('hide');
                                    if (shippingMethod.storePickupEnabled) {
                                        $('.js-shipping-cost-tooltip').addClass('hide');
                                        $('.selectedStoreRecap').show();
                                        $('.payment-step-modal .selectedPickupPointRecap').hide();
                                        $('.js-recap-store-name').text($('.payment-step-modal .selectedStoreRecap .js-store-name').text()).removeClass('hide');
                                        $('.js-shipping-type-' + shippingMethod.ID).addClass('shop-selected');
                                        Shipping.methods.hideAddressForm('pickup');
                                        Shipping.methods.setMandatoryBilling();
                                    } else if (shippingMethod.pointPickupEnabled) {
                                        $('.payment-step-modal .selectedPickupPointRecap').show();
                                        $('.selectedStoreRecap').hide();
                                        $('.js-shipping-type-' + shippingMethod.ID).addClass('shop-selected');
                                        Shipping.methods.hideAddressForm('pup');
                                        Shipping.methods.setMandatoryBilling();
                                    } else {
                                        $('.selectedStoreRecap').hide();
                                        $('.payment-step-modal .selectedPickupPointRecap').hide();
                                        if (shippingMethod.isExpressShipping) {
                                            $('.analyticsExpressShipping').data('is-express-shipping', 'true');
                                        }
                                        if (shippingMethod.isElectronicShipping) {
                                            Shipping.methods.hideAddressFormForGiftcard();
                                            Shipping.methods.setMandatoryBilling();
                                        } else {
                                            Shipping.methods.showAddressForm();
                                            Shipping.methods.resetBillingState();
                                        }
                                    }
                                    if (shippingMethod.shippingPromoMessage) {
                                        $('.payment-promo-message-container').addClass('hidden');
                                        $('.shipping-promo-message-container').removeClass('hidden');
                                        $('.shipping-promo-message-title').empty().text(shippingMethod.shippingPromoMessage);
                                    } else {
                                        if ($('.payment-promo-message-container').data('promo-payment') === true) {
                                            $('.payment-promo-message-container').removeClass('hidden');
                                        }
                                        $('.shipping-promo-message-container').addClass('hidden');
                                    }

                                    // MEC-11999 - show "courier" informative message
                                    let isCourierSelected = 'shippingType' in shippingMethod && shippingMethod.shippingType && shippingMethod.shippingType.value === 'courier';
                                    $('.js-express-courier-message').toggleClass('hide', !isCourierSelected);
                                }
                            });
                            if (data.shipments[0].shippingCostLabel) $('.js-shipping-cost-label').text(data.shipments[0].shippingCostLabel);
                            if (data.shipments[0].deliveryInterval) $('.js-recap-type-delivery-interval').text(data.shipments[0].deliveryInterval);
                            if (data.shipments[0].deliveryMethod) $('.js-recap-type-delivery-method').text(data.shipments[0].deliveryMethod);
                        }
                        Cart.validateBasket(data);
                        $('.shipping-method-list-express .shipping-type-aggregator').sort(function (a, b) {
                            if ($(a).find('.shipping-method-express-confirmed').length) {
                                return -100;
                            } else if ($(b).find('.shipping-method-express-confirmed').length) {
                                return 100;
                            }
                            return $(a).data('index') - $(b).data('index');
                        }).appendTo('.shipping-method-list-express');
                    }
                    $.spinner().stop();
                    $('.error-message.generic-express').hide();
                    $('#expressButtonModal').attr('data-modal-stage', 'payment');
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });

        $('body').on('click', '.js-expressButtonEdit', (e) => {
            e.preventDefault();
            let shippingType = 'home_standard';
            if ($(e.currentTarget).closest('.card.shipping-recap').find('.selectedStoreRecap').css('display') !== 'none') {
                shippingType = 'shop';
            } else if ($(e.currentTarget).closest('.card.shipping-recap').find('.selectedPickupPointRecap').css('display') !== 'none') {
                shippingType = 'pickup_point';
            } else if ($(e.currentTarget).closest('.card.shipping-recap').find('.analyticsExpressShipping').data('is-express-shipping') === 'true') {
                shippingType = 'home_express';
            }
            $('body').trigger('analytics:changeFastShippingMethod', {
                method: shippingType
            });
            $('#expressButtonModal').attr('data-modal-stage', 'shipping');
        });
    }
}

const expressCheckout = new ExpressCheckout();
export default expressCheckout;
